import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { HiExclamationCircle } from 'react-icons/hi2';
import { FullPageState } from '@/components/common/States';
import { IncidentId } from '@/components/common/States/FullPageState.styled';

interface IncidentPageProps {
  incidentId?: string;
  onRetry?: () => void;
}

function generateIncidentId(): string {
  const seg = () => Math.floor(Math.random() * 0xffff).toString(16).padStart(4, '0');
  return `SCR-${seg()}-${seg()}`;
}

export default function IncidentPage({ incidentId, onRetry }: IncidentPageProps) {
  const { t } = useTranslation();
  const id = incidentId ?? generateIncidentId();

  return (
    <FullPageState
      tone="navy"
      dark
      glyph={<HiExclamationCircle />}
      title={t('states.incident.title')}
      body={t('states.incident.body')}
      actions={
        <Button variant="warning" onClick={onRetry ?? (() => window.location.reload())}>
          {t('states.incident.refresh')}
        </Button>
      }
      meta={
        <IncidentId>
          {t('states.incident.ticket')}&nbsp;<b>{id}</b>
        </IncidentId>
      }
    />
  );
}
